import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import 'react-datepicker/dist/react-datepicker.css';
import { Process, General } from '../redux/action/action';
import { Accordion } from 'react-bootstrap';
import 'moment/locale/es';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';

import { Tools } from '../utils/tools';
import FormFields from '../services/FormFields';
import { Global } from '../services/Global';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';
import { SUBMISSION_TYPE, TYPE_FORM } from '../utils/constants';

let _fd = (localStorage.getItem('app_fd')) ? JSON.parse(Tools.decryptrData(localStorage.getItem('app_fd'))) : {};

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class AcademicInformationPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: (_fd.aditional_data !== null) ? _fd.aditional_data : FormFields.aditional_data,
            next_active: true,
            itemSelect: null,
            ismaes: false,
            show_range_date: false,
            range_date: null,
            datasend_current: null,
            headerInformation: {
                title1: 'Información Académica - Pregrado',
                title2: 'Información Académica - Postgrado (Obligatorio)',
                title3: 'Agregar Otros Estudios (Opcional)'
            },
            selectionRange: {
                startDate: null,
                endDate: null,
                key: 'selection'
            },

            search_result: [],

            fechaDesde1: '',
            fechaHasta1: '',
            fechaDesde2: '',
            fechaHasta2: '',
            fechaDesde3: '',
            fechaHasta3: '',

            datasend: {
                1: {
                    id: '',
                    idSubmission: '',
                    idTipo: '1',
                    idInstitucionEducativa: '',
                    idGradoEstudio: 15,
                    profesion: '',
                    fechaDesde: '',
                    fechaHasta: '',
                    ciudad: '',
                    especialidad: '',
                    orden: '',
                    estado: ''
                },
                2: {
                    id: '',
                    idSubmission: '',
                    idTipo: '2',
                    idInstitucionEducativa: 1,
                    idGradoEstudio: 15,
                    profesion: '',
                    fechaDesde: '',
                    fechaHasta: '',
                    ciudad: '',
                    especialidad: '',
                    orden: '',
                    estado: ''
                },
                3: {
                    id: '',
                    idSubmission: '',
                    idTipo: '3',
                    idInstitucionEducativa: 1,
                    idGradoEstudio: 15,
                    profesion: '',
                    fechaDesde: '',
                    fechaHasta: '',
                    ciudad: '',
                    especialidad: '',
                    orden: '',
                    estado: ''
                }
            }
        }
    }

    componentDidMount() {
        let _root = this;
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            let opcam = JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp')));
            if (opcam.label === 'Maestría') {
                _root.setState({
                    ismaes: true
                });
            }
            else {
                _root.setState({
                    ismaes: false
                });
            }

            if (_root.props.pro.tipoPrograma === 'DOCT') {
                _root.setState({
                    headerInformation: {
                        title1: 'Información Académica - Postgrado (Obligatorio)',
                        title2: 'Información Académica - Pregrado (Obligatorio) *',
                        title3: 'Agregar Otros Estudios (Opcional)'
                    }
                });
            }


            Tools.showPreloader();

            let _idSubmission = _root.props.pro.idSubmission;
            if (_root.props.glo.userfindsub !== null) {
                _idSubmission = _root.props.glo.userfindsub.idSubmission;
            }
            ApiService.getData(`${APIS.estudioAcademicoByIdSubmission}${_idSubmission}`)
                .then(res => {
                    if (res.data.length > 0) {
                        for (let item of res.data) {
                            console.log(`Tipo ${item.idTipo}`, item)
                            _root.state.datasend[item.idTipo].id = (_root.props.glo.userfindsub !== null) ? 0 : item.id;
                            _root.state.datasend[item.idTipo].idSubmission = _idSubmission;
                            _root.state.datasend[item.idTipo].idTipo = item.idTipo;
                            _root.state.datasend[item.idTipo].idInstitucionEducativa = item.idInstitucionEducativa;
                            _root.state.datasend[item.idTipo].idGradoEstudio = item.idGradoEstudio;//_root.props.glo.otherinfo?.nivelAcademico;
                            _root.state.datasend[item.idTipo].profesion = item.profesion;
                            _root.state.datasend[item.idTipo].fechaDesde = Global.convertDateStartEnd(item.fechaDesde);
                            _root.state.datasend[item.idTipo].fechaHasta = Global.convertDateStartEnd(item.fechaHasta);
                            _root.state.datasend[item.idTipo].ciudad = item.ciudad;
                            _root.state.datasend[item.idTipo].especialidad = item.especialidad;
                            _root.state.datasend[item.idTipo].orden = item.orden;
                            _root.state.datasend[item.idTipo].estado = item.estado;

                            if (item.idInstitucionEducativa === 1) {
                                console.log('SIN RESPUESTA');
                            }
                            if (item.idInstitucionEducativa !== "") {
                                ApiService.getData(`${APIS.institucionEducativa}${item.idInstitucionEducativa}`).then(resie => {
                                    if (resie.data.nombre !== undefined) {
                                        if (document.getElementById(`idInstitucionEducativa${item.idTipo}`)) { document.getElementById(`idInstitucionEducativa${item.idTipo}`).value = resie.data.nombre };
                                    }
                                }).catch(err => {
                                    console.log(err);
                                });
                            }


                            if (document.getElementById(`profesion${item.idTipo}`)) { document.getElementById(`profesion${item.idTipo}`).value = item.profesion };
                            if (document.getElementById(`especialidad${item.idTipo}`)) { document.getElementById(`especialidad${item.idTipo}`).value = item.especialidad };
                            if (document.getElementById(`idGradoEstudio${item.idTipo}`)) { document.getElementById(`idGradoEstudio${item.idTipo}`).value = item.idGradoEstudio };
                            if (document.getElementById(`ciudad${item.idTipo}`)) { document.getElementById(`ciudad${item.idTipo}`).value = item.ciudad };

                            _root.setState({
                                datasend: _root.state.datasend,
                                [`fechaDesde${item.idTipo}`]: Global.convertDateStartEnd(item.fechaDesde),
                                [`fechaHasta${item.idTipo}`]: Global.convertDateStartEnd(item.fechaHasta),
                            });
                        }
                    }
                    else {
                        console.log('this.props.pro.idInstitucionEducativa', this.props.pro.institucionProcedencia);

                        if (this.props.pro.institucionProcedencia !== "") {
                            ApiService.getData(`${APIS.institucionEducativa}${this.props.pro.institucionProcedencia}`)
                                .then(resie => {
                                    _root.state.datasend['1'].idSubmission = _idSubmission;
                                    _root.state.datasend['1'].profesion = _root.props.glo.otherinfo?.profesion;
                                    _root.state.datasend['1'].idGradoEstudio = _root.props.glo.otherinfo?.nivelAcademico;

                                    if (document.getElementById(`profesion${1}`)) { document.getElementById(`profesion${1}`).value = _root.props.glo.otherinfo?.profesion };
                                    if (document.getElementById(`idGradoEstudio${1}`)) { document.getElementById(`idGradoEstudio${1}`).value = _root.props.glo.otherinfo?.nivelAcademico };

                                    if (resie.data.id) {
                                        if (resie.data.nombre !== undefined) {
                                            if (document.getElementById(`idInstitucionEducativa1`)) { document.getElementById(`idInstitucionEducativa1`).value = resie.data.nombre };
                                            _root.state.datasend['1'].idInstitucionEducativa = resie.data.id;
                                            _root.setState({
                                                datasend: _root.state.datasend
                                            }, () => {
                                                //console.log( _root.state.datasend );
                                            });
                                        }
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                    }
                    _root.setState({
                        datasend: _root.state.datasend
                    });

                    Tools.hidePreloader();
                })
                .catch(err => {
                    Tools.hidePreloader();
                    console.log(err);
                });

            _root.setState({
                program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp'))),
                item: _root.state.item
            });
        }
    }

    onChangeDateRange = (ranges) => {
        // console.log(ranges);
    }

    onFocus = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        if (_target.name === 'fechaDesde' || _target.name === 'fechaHasta') {
            _root.setState({
                datasend_current: _target.getAttribute('data-level')
            });
        }
    }

    onChange = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        if (_root.props.pro[_target.name] !== undefined) {
            _root.props.pro[_target.name] = _target.value;
            _root.checkFields(Global.checkFormData(_target, _root.state, 'academy_information', _root.props.pro), 'onchange');
        }
        else {
            // console.log("onCHnge: ",_target.getAttribute('data-type'));
            if (_target.getAttribute('data-type')) {
                if (_target.getAttribute('data-type') === 'search') {
                    _root.setState({
                        search_result: []
                    }, () => {
                        if (_target.value.length > 1) {
                            // console.log(_target.value);
                            ApiService.getData(`${APIS.institucionesEducativasNombre}/${_target.value}`)
                                .then(res => {
                                    // console.log(res);
                                    if (res.data.length > 0) {
                                        _root.setState({
                                            search_result: res.data
                                        }, () => {
                                            if (_target.parentNode.querySelectorAll('.search-result').length > 0) {
                                                _target.parentNode.querySelectorAll('.search-result')[0].style.display = 'block';
                                            }
                                        });
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                        else {
                            console.log('sin resultados');
                            _root.state.datasend[_target.getAttribute('data-level')]['idInstitucionEducativa'] = 1; //Sin respuesta
                            _root.setState({
                                datasend: _root.state.datasend,
                                search_result: []
                            }, () => {
                                if (_target.parentNode.querySelectorAll('.search-result').length > 0) {
                                    _target.parentNode.querySelectorAll('.search-result')[0].style.display = 'none';
                                }
                            });
                        }
                    });
                }
            }
            else {
                _root.state.datasend[_target.getAttribute('data-level')]['idSubmission'] = _root.props.pro.idSubmission;
                _root.state.datasend[_target.getAttribute('data-level')][_target.name] = _target.value;
                _root.state.datasend[_target.getAttribute('data-level')].idTipo = _target.getAttribute('data-level');
                _root.setState({
                    datasend: _root.state.datasend
                }, () => {
                    // console.log( _root.state.datasend );
                });
            }
        }
    }

    checkFields(state, evt) {
        let _root = this;
        let _formValidation = Global.formValidation('academy_information', state.fields, _root.props.pro);

        _root.setState({
            fields: state.fields,
            next_active: _formValidation
        }, () => {
            if (evt === 'onblur') {
                if (_formValidation) {
                    _fd.general_data = state.fields;
                    localStorage.setItem('app_fd', Tools.cryptrData(JSON.stringify(_fd)));
                }
            }
        });
    }

    promiseOptions = (inputValue) => {
        if (!inputValue) {
            return [];
        }
        else {
            ApiService.getData(`${APIS.institucionesEducativasNombre}/${inputValue}`)
                .then(res => {
                    let items = [];
                    for (let item of res.data) {
                        items.push({ value: item.id, label: item.nombre });
                    }
                    return items;
                })
                .catch(err => {
                    return [];
                });
        }
    }

    onClickResultItem = (e) => {
        e.preventDefault();
        let _root = this;
        let _target = e.currentTarget;

        if (_target.getAttribute('data-id')) {
            _root.state.datasend[_target.getAttribute('data-level')]['idInstitucionEducativa'] = parseInt(_target.getAttribute('data-id'));
            document.getElementById(`${_target.getAttribute('data-name')}${_target.getAttribute('data-level')}`).value = _target.getAttribute('data-value');
            for (let item of document.querySelectorAll('.search-result')) {
                item.style.display = 'none';
            }
        }
    }



    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;

        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/informacion-academica'));
        _root.props.process(_root.props.pro);
        _root.props.general(_root.props.glo);

        //validation fields
        let isValidateForm = [];
        //List promises actions
        let promiseAcademicInformation = [];
        //Informacion academica #1
        isValidateForm = [...Global.validateFormAcademicInformation(TYPE_FORM.INF_ACADEMIC_PREGRADO, _root)];

        if (_root.props.pro.tipoPrograma === "DOCT") {
            console.log('TYPE_FORM.INF_ACADEMIC_POSTGRADO', _root.props.pro.tipoPrograma);
            isValidateForm.push(...Global.validateFormAcademicInformation(TYPE_FORM.INF_ACADEMIC_POSTGRADO, _root, _root.props.pro.tipoPrograma));
        } else {
            [TYPE_FORM.INF_ACADEMIC_POSTGRADO, TYPE_FORM.INF_ACADEMIC_OTHERS].forEach(element => {
                if (_root.state.datasend[element] !== null && _root.state.datasend[element].idInstitucionEducativa !== 1) {
                    isValidateForm.push(...Global.validateFormAcademicInformation(element, _root, _root.props.pro.tipoPrograma));
                }
            });
        }

        console.log('isValidateForm', isValidateForm.length, isValidateForm);
        if (isValidateForm.length > 0) return false;

        console.log('Data 1', _root.state.datasend['1']);
        console.log('Data 2', _root.state.datasend['2']);
        console.log('Data 3', _root.state.datasend['3']);

        Tools.showPreloader();
        _root.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO]['fechaDesde'] = (`20-${_root.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO]['fechaDesde']}`).split('-').reverse().join('-');
        _root.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO]['fechaHasta'] = (`20-${_root.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO]['fechaHasta']}`).split('-').reverse().join('-');
        promiseAcademicInformation.push(ApiService.postData(`${APIS.estudioAcademico}`, _root.state.datasend[TYPE_FORM.INF_ACADEMIC_PREGRADO]));

        [TYPE_FORM.INF_ACADEMIC_POSTGRADO, TYPE_FORM.INF_ACADEMIC_OTHERS].forEach(element => {
            if (_root.state.datasend[element] !== null && _root.state.datasend[element].idInstitucionEducativa !== 1) {

                _root.state.datasend[element]['fechaDesde'] = (`20-${_root.state.datasend[element]['fechaDesde']}`).split('-').reverse().join('-');
                _root.state.datasend[element]['fechaHasta'] = (`20-${_root.state.datasend[element]['fechaHasta']}`).split('-').reverse().join('-');
                promiseAcademicInformation.push(ApiService.postData(`${APIS.estudioAcademico}`, _root.state.datasend[element]));
            }
            else if (_root.state.datasend[element] !== null && _root.state.datasend[element].idInstitucionEducativa === 1 && _root.state.datasend[element].id !== '') {
                let _estudioAcademico = { ..._root.state.datasend[element] };
                promiseAcademicInformation.push(ApiService.deleteData(`${APIS.estudioAcademico}/${_estudioAcademico.id}`));
            }
        });

        Promise.all(promiseAcademicInformation)
            .then(responses => {
                console.log('responses', responses);
                Tools.hidePreloader();
                _root.props.navigate('/informacion-laboral');
            }).catch(err => {
                Tools.hidePreloader();
                console.log(err);
            });


    }

    onChangeDate = (e) => {
        let _root = this;
        let _target = e.target;

        if (_target.name !== undefined) {
            if (_target.name === 'fechaDesde' || _target.name === 'fechaHasta') {
                let levelForm = _target.getAttribute('data-level');

                document.getElementById(`${_target.name}${levelForm}`).value = _target.value;
                _root.state.datasend[levelForm][_target.name] = _target.value;
                _root.setState(
                    {
                        datasend: _root.state.datasend,
                        [`${_target.name}${levelForm}`]: _target.value,
                    });
            }
        }

    }

    onSearchChange = (itemSelect) => {
        let _root = this;
        if (itemSelect) {
            _root.setState({
                itemSelect
            });
        }
    }

    render() {

        const {
            ismaes,
            next_active,
            program_selected,
            search_result,
            fechaDesde1,
            fechaHasta1,
            fechaDesde2,
            fechaHasta2,
            fechaDesde3,
            fechaHasta3
        } = this.state;

        const {
            navigate
        } = this.props;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                            {(program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'2'} form={program_selected.form} /> : <></>}
                        </div>
                        <div className="col-md-9 right-side-dashboard">
                            <TopProcessComponent porcent="40" />
                            <div className="row content-dashboard">
                                <div className="col-sm-12">
                                    <div className="row pt-3 pb-3">
                                        <div className="col-sm-12 col-md-6">
                                            {/* <TopComponent direction="back" label="Paso Previo" onClick path="/datos-conyuge" /></div> */}
                                            <TopComponent direction="back" 
                                            label="Paso Previo " 
                                            path={ (this.props.pro.tipoPrograma === "SEG") ? '/datos-generales' : "/datos-conyuge"} /></div>
                                        <div className="col-sm-12 col-md-6">
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-12">
                                            {this.props.pro.tipoPrograma == "DOCT" ?
                                                <h6><strong>Información Académica - Postgrado (Obligatorio)</strong></h6> : <h6><strong>Información Académica - Pregrado (Obligatorio)</strong></h6>
                                            }

                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2 search-form">
                                                <label htmlFor="institucionProcedencia" className="pb-2">Institución Educativa <span className="text-danger">*</span></label>
                                                <input data-level="1" type="text" className="form-control" id="idInstitucionEducativa1" data-type="search" placeholder="Escribe el nombre de la institución" aria-describedby="nameHelp" onChange={this.onChange} autoComplete="off" />
                                                <div className="invalid-feedback"></div>
                                                <div className="search-result">
                                                    {
                                                        search_result.map((item, i) => (
                                                            <div key={(i + 1) + 'inedu'} data-id={item.id} data-level="1" data-name="idInstitucionEducativa" data-value={item.nombre} className="search-result-item" onClick={this.onClickResultItem}>
                                                                <small>{item.nombre}</small>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="profesion1" className="pb-2">Profesión <span className="text-danger">*</span></label>
                                                <input data-level="1" size={150} type="text" className="form-control" id="profesion1" name="profesion" aria-describedby="nameHelp" onChange={this.onChange} />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="grado" className="pb-2">Grado <span className="text-danger">*</span></label>
                                                <select data-level="1" defaultValue='' className="form-control" id="idGradoEstudio1" name="idGradoEstudio" onChange={this.onChange}>
                                                    <option value={''} >Selecciona una opción</option>
                                                    {
                                                        this.props.glo.gradosAcademicos.filter(e => ((this.props.pro.tipoPrograma == "DOCT") ? [16, 8] : [14, 7]).includes(e.id)).map((item, i) => (
                                                            <option key={(i + 1) + 'gaca'} value={item.id}>{item.nombre}</option>
                                                        ))
                                                    }
                                                </select>
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2 gri">
                                                <label htmlFor="fechaDesde" className="pb-2">Desde - Hasta<span className="text-danger">*</span></label>
                                                <div className="input-tg-inline">
                                                    <InputMask maskChar="" data-level="1" id="fechaDesde1" className="form-control" mask="99-9999" name="fechaDesde" value={fechaDesde1} onChange={this.onChangeDate} autoComplete="off" placeholder="Mes y año, ejm: 04-2001" />
                                                    <InputMask maskChar="" data-level="1" id="fechaHasta1" className="form-control" mask="99-9999" name="fechaHasta" value={fechaHasta1} onChange={this.onChangeDate} autoComplete="off" placeholder="Mes y año, ejm: 05-2002" />
                                                    <div className="invalid-feedback"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12">
                                            <Accordion defaultActiveKey={this.props.pro.tipoPrograma == "DOCT" ? ["0"] : []} >
                                                <Accordion.Item eventKey="0">
                                                    {this.props.pro.tipoPrograma == "DOCT" ?
                                                        <Accordion.Header>Información Académica - Pregrado (Obligatorio)</Accordion.Header> : <Accordion.Header>Información Académica - Postgrado (Opcional)</Accordion.Header>
                                                    }
                                                    <Accordion.Body>
                                                        <div className="row pt-2 pb-2">
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2 search-form">
                                                                    <label htmlFor="insti_educa_grado" className="pb-2">Institución Educativa</label>
                                                                    <input data-level="2" type="text" className="form-control" id="idInstitucionEducativa2" data-type="search" placeholder="Escribe el nombre de la institución" aria-describedby="nameHelp" onChange={this.onChange} autoComplete="off" />
                                                                    <div className="search-result">
                                                                        {
                                                                            search_result.map((item, i) => (
                                                                                <div key={(i + 1) + 'inedu'} data-id={item.id} data-level="2" data-name="idInstitucionEducativa" data-value={item.nombre} className="search-result-item" onClick={this.onClickResultItem}>
                                                                                    <small>{item.nombre}</small>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="especialidad" className="pb-2">Especialidad</label>
                                                                    <input data-level="2" type="text" className="form-control" id="especialidad2" name="especialidad" aria-describedby="nameHelp" onChange={this.onChange} />
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="grado" className="pb-2">Grado</label>
                                                                    <select data-level="2" defaultValue='' className="form-control" id="idGradoEstudio2" name="idGradoEstudio" onChange={this.onChange}>
                                                                        <option value={''} >Selecciona una opción</option>
                                                                        {
                                                                            this.props.glo.gradosAcademicos.filter(e => ((this.props.pro.tipoPrograma === "DOCT") ? [14, 7] : [16, 8]).includes(e.id)).map((item, i) => (
                                                                                <option key={(i + 1) + 'gaca'} value={item.id}>{item.nombre}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2 gri">
                                                                    <label htmlFor="fechaDesde" className="pb-2">Desde - Hasta {(ismaes) ? '' : ''}</label>
                                                                    <div className="input-tg-inline">
                                                                        <InputMask maskChar="" data-level="2" id="fechaDesde2" className="form-control" mask="99-9999" name="fechaDesde" value={fechaDesde2} onChange={this.onChangeDate} onFocus={this.onFocus} autoComplete="off" placeholder="Mes y año, ejm: 04-2001" />
                                                                        <InputMask maskChar="" data-level="2" id="fechaHasta2" className="form-control" mask="99-9999" name="fechaHasta" value={fechaHasta2} onChange={this.onChangeDate} onFocus={this.onFocus} autoComplete="off" placeholder="Mes y año, ejm: 05-2002" />
                                                                        <div className="invalid-feedback"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="2">
                                                    <Accordion.Header>Agregar Otros Estudios (Opcional)</Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="row pt-2 pb-2">
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2 search-form">
                                                                    <label htmlFor="insti_educa_otro" className="pb-2">Institución Educativa</label>
                                                                    <input data-level="3" data-type="search" type="text" className="form-control" id="idInstitucionEducativa3" placeholder="Escribe el nombre de la institución" aria-describedby="nameHelp" onChange={this.onChange} autoComplete="off" />
                                                                    <div className="search-result">
                                                                        {
                                                                            search_result.map((item, i) => (
                                                                                <div key={(i + 1) + 'inedu'} data-id={item.id} data-level="3" data-name="idInstitucionEducativa" data-value={item.nombre} className="search-result-item" onClick={this.onClickResultItem}>
                                                                                    <small>{item.nombre}</small>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        <div className="invalid-feedback"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="especialidad_otro" className="pb-2">Especialidad</label>
                                                                    <input data-level="3" type="text" className="form-control" id="especialidad3" name="especialidad" aria-describedby="nameHelp" onChange={this.onChange} />
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2 gri">
                                                                    <label htmlFor="fechaDesde" className="pb-2">Desde - Hasta</label>
                                                                    <div className="input-tg-inline">
                                                                        <InputMask maskChar="" data-level="3" id="fechaDesde3" className="form-control" mask="99-9999" name="fechaDesde" value={fechaDesde3} onChange={this.onChangeDate} onFocus={this.onFocus} autoComplete="off" placeholder="Mes y año, ejm: 04-2001" />
                                                                        <InputMask maskChar="" data-level="3" id="fechaHasta3" className="form-control" mask="99-9999" name="fechaHasta" value={fechaHasta3} onChange={this.onChangeDate} onFocus={this.onFocus} autoComplete="off" placeholder="Mes y año, ejm: 05-2002" />
                                                                        <div className="invalid-feedback"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <small className="text-danger">*Obligatorio</small>
                                        </div>
                                        <div className="col-sm-12 col-md-4"></div>
                                        <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                            <button className={(next_active) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'} onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AcademicInformationPage);